import { EnvironmentConfiguration } from "../app/models/EnvironmentConfiguration";

const serverUrl='https://localhost:44325/api';

export const environment: EnvironmentConfiguration = {
  env_name: 'dev',
  production: true,
  apiUrl: serverUrl,
  apiEndpoints: {
    accountMapping: 'AccountMapping',
    sourceAccount: 'GroupAccount',
    groupAccount: 'SourceAccount'
  },
  adConfig: {
    clientId: '51da6cb3-dd54-4894-99f6-de5ac6dbee86',
    readScopeUrl: 'https://initFinance.onmicrosoft.com/dev/finance-api/Records.Update',
    writeScopeUrl: 'https://initFinance.onmicrosoft.com/dev/finance-api/Records.Read',
    scopeUrls:[
      'https://initFinance.onmicrosoft.com/dev/finance-api/Records.Update',
      'https://initFinance.onmicrosoft.com/dev/finance-api/Records.Read'
    ],
    apiEndpointUrl: 'https://localhost:44325/api',
    tenantId: '8d4b057e-b023-45a2-8ddc-f57c4cfaba5a'
  },
  cacheTimeInMinutes: 30,
};